import { Base } from '@studiometa/js-toolkit';

/**
 * StickyBar
 */
export default class ProductStickyBar extends Base {
  static config = {
    name: 'ProductStickyBar',
  };

  isVisible = false;

  /**
   * Get Main Add To Cart position
   * @returns {number}
   */
  get addToCartPosition() {
    return this.$parent.$refs.addToCart.getBoundingClientRect().top;
  }

  /**
   * Service scrolled hook
   * @see https://js-toolkit.studiometa.dev/api/methods-hooks-services.html#scrolled
   * @returns {void}
   */
  scrolled() {
    const position = this.addToCartPosition;

    if (position < 50 && !this.isVisible) {
      this.$el.classList.remove('translate-y-full');
      this.isVisible = true;
      return;
    }

    if (this.isVisible && position >= 50) {
      this.isVisible = false;
      this.$el.classList.add('translate-y-full');
    }
  }
}
